module.exports = __webpack_public_path__ + "static/media/img30.e28354cf.jpg";